import classNames from 'classnames/bind';
import { ReactElement } from 'react';

import Styles from './Radio.module.scss';

const cx = classNames.bind(Styles);

interface Props<T> {
  /** Dictates whether radio input is disabled or not */
  disabled?: boolean;
  /** Radio input value */
  value?: T;
  /** Radio input label */
  label: string | ReactElement;
  /** Radio input id */
  id?: string;
  /** Radio input group name */
  name: string;
  /** Radio input onChange callback (target value is passed into onChange func) */
  onChange: (value: T) => void;
  /**Default selected value */
  isSelected?: boolean;
  /** One per line, tight against its neighbours — the same prop Checkbox takes. Without it two
   * adjacent radios are laid out side by side and the second picks up a left margin. */
  stacked?: boolean;
}

const Radio = <T extends string | number>(props: Props<T>) => {
  const { disabled = false, value, name, label, id, onChange, isSelected, stacked = false, ...otherProps } = props;

  const handleChange = (event) => {
    if (onChange && !disabled) {
      onChange(event.target.value as T);
    }
  };

  return (
    <label className={cx('form-element', 'radio', { 'radio--disabled': disabled }, { stacked }, { fw: stacked })}>
      <input
        type='radio'
        id={id}
        value={value as string | number}
        ref={(el) => {
          el;
        }}
        {...otherProps}
        disabled={disabled}
        name={name}
        className={cx('radio__input', { 'radio__input--disabled': disabled })}
        tabIndex={disabled ? -1 : 0}
        onChange={handleChange}
        checked={isSelected}
      />
      <span className={cx('radio__text')}>{label}</span>
    </label>
  );
};

export default Radio;
